import Swal from "sweetalert2";
import { Constants } from "../../utils/Constants";
import "./CadastroConclusao.scss";

export const CONCLUSAO_CADASTRO = {
	matriz: {
		titulo: "Cadastro realizado com sucesso!",
		intro: "Recebemos os dados da sua empresa e o cadastro seguirá para análise.",
	},
	filial: {
		titulo: "Filial cadastrada com sucesso!",
		intro: "Recebemos os dados da nova Filial e o cadastro seguirá para análise.",
	},
};

export const CONCLUSAO_PRAZO =
	"Prazo para retorno: até 20 minutos. Assim que o acesso for liberado, você receberá uma confirmação no e-mail cadastrado.";

export function htmlConclusaoCadastro(variante) {
	const copy = CONCLUSAO_CADASTRO[variante] || CONCLUSAO_CADASTRO.matriz;
	const whatsapp = Constants.whatsappLink;
	return `
		<p class="ff-conclusao__intro">${copy.intro}</p>
		<div class="ff-conclusao__prazo">${CONCLUSAO_PRAZO}</div>
		<p class="ff-conclusao__ajuda-titulo">Precisa de ajuda?</p>
		<p class="ff-conclusao__ajuda">Entre em contato com nossa Central de Relacionamento.</p>
		<a class="ff-conclusao__whatsapp" href="${whatsapp}" target="_blank" rel="noopener noreferrer">Falar pelo WhatsApp</a>
		<p class="ff-conclusao__rodape">Agradecemos por escolher a FastFrete.</p>
	`;
}

export function mostrarConclusaoCadastro(variante) {
	const copy = CONCLUSAO_CADASTRO[variante] || CONCLUSAO_CADASTRO.matriz;
	return Swal.fire({
		icon: "success",
		title: copy.titulo,
		html: htmlConclusaoCadastro(variante),
		confirmButtonText: "Fechar",
		confirmButtonColor: "#2A449A",
		allowOutsideClick: false,
		customClass: {
			popup: "ff-conclusao-cadastro",
			title: "ff-conclusao__titulo",
			htmlContainer: "ff-conclusao__html",
			confirmButton: "ff-conclusao__fechar",
		},
	});
}

export function avisoEmpresaEmAnalise() {
	return Swal.fire({
		title: "Cadastro em análise",
		text: "Esta empresa ainda não foi liberada. Até a FastFrete aprovar, não é possível acessar, ofertar, programar recebimento nem aceitar agenda neste CNPJ.",
		icon: "info",
		confirmButtonText: "Fechar",
		confirmButtonColor: "#2A449A",
	});
}
